export const resetValidatonErrors = (errs: any, setErrors: any) => {
  const errors = errs;
  for (const error in errs) {
    errors[error] = "";
  }
  setErrors(errors);
};

const handleValidationError = (err: any) => {
  const errors = err.inner.reduce(
    (error: any, errs: any) => ({ ...error, [errs.path]: errs.message }),
    {}
  );

  return errors;
};

export default handleValidationError;
